<template>
  <v-dialog v-model="localDialog" persistent width="600">
    <v-card>
      <v-card-title class="text-h6 primary white--text"> Remanejo de Aluno </v-card-title>

      <v-card-text class="pt-4">
        <v-alert type="info" dense class="mb-4">
          <div><strong>Aluno:</strong> {{ matricula?.nomecompleto || "..." }}</div>
          <div><strong>Escola:</strong> {{ escolaDescricao }}</div>
          <div><strong>Turma Atual:</strong> {{ matricula?.TURMA || "..." }}</div>
          <div><strong>Série:</strong> {{ serieDescricao }}</div>
        </v-alert>

        <v-select
          v-model="turmaSelecionada"
          :items="turmasDisponiveis"
          item-text="descricao"
          item-value="id"
          return-object
          label="Selecione a turma de destino *"
          :hint="turmaSelecionada ? turmaSelecionada.descricao : 'Selecione uma turma'"
          persistent-hint
          outlined
          :loading="carregandoTurmas"
          :rules="[(v) => !!v || 'Selecione uma turma']"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.descricao }}</v-list-item-title>
              <v-list-item-subtitle v-if="item.turno">
                {{ item.turno.descricao }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-select>

        <v-alert v-if="!turmasDisponiveis.length && !carregandoTurmas" type="warning" dense>
          Não há turmas disponíveis da mesma série nesta escola.
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="fecharModal">Cancelar</v-btn>
        <v-btn color="primary" @click="confirmarRemanejo" :disabled="!turmaSelecionada">
          Confirmar Remanejo
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    matricula: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      localDialog: this.dialog,
      turmaSelecionada: null,
      turmasDisponiveis: [],
      carregandoTurmas: false,
      escolaDescricao: "...",
    };
  },

  computed: {
    serieDescricao() {
      return (
        this.matricula?.turma?.series?.[0]?.descricao || this.matricula?.serie?.descricao || "..."
      );
    },
  },

  watch: {
    dialog: {
      async handler(newVal) {
        this.localDialog = newVal;
        if (newVal && this.matricula) {
          await this.carregarTurmasDisponiveis();
        }
      },
    },
    localDialog(newVal) {
      this.$emit("dialogChange", newVal);
    },
  },

  methods: {
    async carregarTurmasDisponiveis() {
      this.carregandoTurmas = true;
      try {
        // Buscar turmas da mesma escola e série
        const form = {
          franquia: {
            id: this.matricula.turma.configuracao_id,
          },
          matricula: this.matricula,
        };

        // Usar a API existente que já filtra por série
        const turmas = await this.$services.turmasService.listarTurmasFranquiaSelect(form);

        // Filtrar para remover a turma atual
        this.turmasDisponiveis = turmas.filter((turma) => turma.id !== this.matricula.turma_id);

        // Buscar descrição da escola
        await this.buscarEscolaDescricao();
      } catch (error) {
        this.$handleError(error);
        this.turmasDisponiveis = [];
      } finally {
        this.carregandoTurmas = false;
      }
    },

    async buscarEscolaDescricao() {
      try {
        const franquiaId = this.matricula?.turma?.configuracao_id || this.matricula?.ESCOLA;
        if (franquiaId) {
          const franquias = await this.$services.franquiasService.syncAll();
          const franquia = franquias.find((f) => f.id === franquiaId);
          this.escolaDescricao = franquia?.descricao || "...";
        }
      } catch (error) {
        console.error("Erro ao buscar escola:", error);
        this.escolaDescricao = "...";
      }
    },

    fecharModal() {
      this.localDialog = false;
      this.turmaSelecionada = null;
      this.turmasDisponiveis = [];
    },

    async confirmarRemanejo() {
      if (!this.turmaSelecionada) {
        this.$toast.warning("Selecione uma turma de destino");
        return;
      }

      try {
        const form = {
          matriculaTransferida: {
            aluno_id: this.matricula.aluno_id,
            turma_id: this.turmaSelecionada.id,
            serie_id: this.matricula.serie_id,
            situacao: "CURSANDO",
            sistema_bncc_id_turma: this.turmaSelecionada.sistema_bncc_id,
            sistema_bncc: this.matricula.turma?.sistema_bncc_id,
          },
          matricula: this.matricula,
          check: true,
        };

        this.$loaderService.open("Remanejando aluno...");

        await this.$services.matriculasService.transferirMatricula(form);

        this.$loaderService.close();
        this.$toast.success("Aluno remanejado com sucesso!");

        this.$emit("remanejo-concluido");
        this.fecharModal();
        window.location.reload();
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
    },
  },
};
</script>

<style scoped></style>
